import { Component, Logger } from 'lib'
import locale from 'Common/Locale/Locale'
import Image from 'Component/Asset/Image/Image'
import { AnalyticsEventTypes } from 'Common/Service/Analytics/constants'

const partnerImageSrc = '/partners/uber-eats-1.png'
const partnerImageAlt = 'Order with Uber Eats'
const partnerHref
  = 'https://eats.sng.link/A99vk/mi87?_smtype=3&_dl=ubereats%3A%2F%2F&pcn=bd_us_ca_riot_sponsorship_campaign_eats_homepage&_fallback_redirect=https%3A%2F%2Fwww.ubereats.com'
const allowedCountries = ['CA', 'US']
const allowedTournamentIds = [
  '115564596163517554', // LCS Split 1
  '115564760172712809', // LCS Split 2
  '115564797158840434', // LCS Split 3
  '115660540725177488' // Worlds 2026
]

class PartnerBanner extends Component {
  /**
   * @type {{ analyticsService: import('Common/Service/Analytics/types').IAnalyticsService }}
   */
  context

  constructor () {
    super()
    this.log = new Logger(this.constructor.name)
  }

  render () {
    const geoInfo = locale.getGeoInfo()

    if (!allowedTournamentIds.includes(this.props.tournamentId)) {
      this.log.info(
        `Skipped rendering partner banner for tournamentId: ${this.props.tournamentId}`
      )
      return
    }

    if (!allowedCountries.includes(geoInfo?.code)) {
      this.log.info(
        `Skipped rendering partner banner for country code: ${geoInfo.code}`
      )
      return
    }

    this.log.info('Sending analytics event partner_banner:view')
    this.context.analyticsService.track(AnalyticsEventTypes.PartnerBanner, {
      type: 'view'
    })

    const onClick = () => {
      this.log.info('Sending analytics event partner_banner:click')
      this.context.analyticsService.track(AnalyticsEventTypes.PartnerBanner, {
        type: 'click'
      })
    }

    return (
      <div class="PartnerBanner">
        <a onClick={ onClick } href={ partnerHref } target="_blank">
          <Image
            src={ partnerImageSrc }
            size="x50"
            alt={ partnerImageAlt }
            class="partner-image"
          />
        </a>
      </div>
    )
  }
}

export default PartnerBanner
